module.exports = __webpack_public_path__ + "img/icon-close-red.04d5b51b.svg";